﻿"use strict";
export const locations = (function () {
    const url = "/locationApi";
    const method = 'POST';

    async function countriesGet(isEnable = true) {
        const countries = [];
        const outJson = {
            action: 'countriesGet',
            data: {
                isEnable
            }
        };
        const response = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(outJson)
        });

        const results = await response.json();

        for (const item of results) {
            countries.push(item);
        }

        return countries;
    };

    async function countryGet(countryId) {
        const outJson = {
            action: 'countryGet',
            data: {
                countryId
            }
        };
        const response = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(outJson)
        });

        const results = await response.json();


        return results;
    };

    async function citiesGet() {
        const cities = [];
        const outJson = {
            action: 'citiesGet'
        };
        const response = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(outJson)
        });

        const results = await response.json();

        for (const item of results) {
            cities.push(item);
        }

        return cities;
    };

    async function cityGet(cityId) {
        const outJson = {
            action: 'cityGet',
            data: {
                cityId
            }
        };
        const response = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(outJson)
        });

        const result = await response.json();

        return result;
    };

    async function regionGet(regionId) {
        const outJson = {
            action: 'regionGet',
            data: {
                regionId
            }
        };
        const response = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(outJson)
        });

        const result = await response.json();

        return result;
    }

    return {
        countriesGet,
        countryGet,
        citiesGet,
        cityGet,
        regionGet
    }
})();